import { makeStyles } from '@material-ui/core/styles';

type CheckboxFieldProps = {
  bordered: boolean;
};

export const useStyles = makeStyles(theme => ({
  input: {
    color: '#2D2D2D',
    padding: '16.5px 15px',
    background: '#fff',
    border: ({ bordered }: CheckboxFieldProps) => (bordered ? `1px solid #ABAFB3` : 'unset'),
    borderRadius: 10,
    '& input': {
      padding: 'unset',
      borderRadius: 'unset',
    },
  },
  label: {
    display: 'flex',
    fontSize: 18,
    fontWeight: 300,
    lineHeight: '30px',
    color: '#000',
    paddingBottom: '5px',
  },
  underline: {
    '&&&:before': {
      borderBottom: 'none',
    },
    '&&:after': {
      borderBottom: 'none',
    },
  },
  disabled: {
    borderRadius: '10px',
    // backgroundColor: ({ disabledVariant }: CheckboxFieldProps) => (disabledVariant === 'grey' ? '#C5C5C5' : 'unset'),
  },
  iconPassword: {
    paddingRight: theme.spacing(2),
  },
}));
